<div class="flex justify-center">

  <div class="voice-player">

    <!-- اطلاعات -->
    <div class="voice-header">

      <div>

        <span class="voice-title">
          {{ titleVoice }}
        </span>

        <span class="voice-desc">
          {{ descVoice }}
        </span>

      </div>

      <img
        loading="lazy"
        class="voice-image"
        src="../../../assets/img/record.webp"
        alt="voice-icon">

    </div>

    <!-- کنترل‌ها -->
    <div class="voice-controls">

      <!-- Play -->
      <button
        class="play-btn"
        (click)="playAudio()"
        aria-label="Play">

        <i
          class="ie-icon"
          [ngClass]="Pause_Play ? 'icon-pause-voice' : 'icon-play-voice'">
        </i>

      </button>

      <!-- زمان سپری شده -->
      <span class="voice-time">

        {{ currentTime }}

      </span>

      <!-- نوار -->
      <div
        #progressBar
        class="progress-bar"
        (click)="startSeek($event)">

      <div
        class="progress"
        [style.width.%]="progressBarValue">
      </div>

      <div class="moveMent-line">
          <div class="tick">
              <div class="line-s"></div>
              <div class="line-e"></div>
          </div>

          <div class="tick">
              <div class="line-s"></div>
              <div class="line-e"></div>
          </div>

          <div class="tick">
              <div class="line-s"></div>
              <div class="line-e"></div>
          </div>

          <div class="tick">
              <div class="line-s"></div>
              <div class="line-e"></div>
          </div>
      </div>

      </div>

      <!-- زمان کل -->
      <span class="voice-time">

        {{ duration }}

      </span>

      <!-- سرعت -->
      <button
        class="speed-btn"
        (click)="changeSpeed()">

        <i
          class="ie-icon"
          [ngClass]="
            speedNum == 1
              ? 'icon-speed-1'
              : speedNum == 2
              ? 'icon-speed-15'
              : 'icon-speed-2'
          ">
        </i>

      </button>

    </div>

  </div>

</div>

<audio
  #audioPlayer
  preload="metadata"
  (timeupdate)="updateTimeDisplay()"
  (loadedmetadata)="updateTimeDisplay()"
  (ended)="Pause_Play=false">

  <source
    [src]="audioSource"
    type="audio/mp3">

  Your browser does not support the audio element.

</audio>